
define('text!templates/app/supervisor/member.html',[],function () { return '<div id="profile" class="tc-row"></div>\n<ul id="navigation" class="nav nav-pills"></ul>\n<div id="content" class="page-content"></div>\n';});

